import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "worksheet" }

import { ref,reactive,computed,watch} from "vue";
import SideMenu from "@/components/SideMenu.vue";
import FootBar from '@/components/FootBar.vue';
import EdgeEditor from "@/components/EdgeEditor.vue";
import NodeEditor from "@/components/NodeEditor.vue";
import { Transition, Nodes, Edges, Parameters } from "@/assets/types";
import { Automaton } from "@/assets/Automaton";
import { unreactiveCopy} from "@/assets/utilities";
import { graphString, downloadAsSvg } from "@/assets/graph";
import { readParams, save, share } from "@/assets/memory";
import { networkGraphConfigs, palette } from "@/assets/predefined";
import * as vNG from "v-network-graph"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initialParams :Parameters = readParams(window.location.search);
const nodes : Nodes = reactive(initialParams.nodes);
const edges : Edges = reactive(initialParams.edges);
const selectedNodes = ref<string[]>([]);
const selectedEdge = ref<string[]>([]);
const nextNodeIndex = ref(Math.max(...Object.keys(nodes).map((k)=>parseInt(k))) + 1)
const nextEdgeIndex = ref(Math.max(...Object.keys(edges).map((k)=>parseInt(k))) + 1);
const initialNode = ref(initialParams.initial);
const alphabet = ref<string[]>(initialParams.alphabet)
const animated = ref(true)
const determinism = ref(initialParams.determinism)
const graph = ref<vNG.Instance>()
const automata = computed(()=>new Automaton(
  nodes, 
  unreactiveCopy(edges), 
  initialNode.value, 
  alphabet.value
))

const params = computed<Parameters>(()=>{
  return {
    nodes: nodes,
    edges: edges,
    alphabet: alphabet.value,
    determinism: determinism.value,
    layout: unreactiveCopy(graph.value?.currentLayouts ?? {}),
    initial: initialNode.value
  }
})

function addNode() {
  // currently nodeID can be assigned to an already existing ID, causing problems
  nodes[nextNodeIndex.value] = {
    name: String(nextNodeIndex.value),
  }

  // se l'utente sta selezionando un nodo mentre aggiunge un nodo, allora collega il nodo selelzionato e il nuovo nodo
  selectedNodes.value.forEach((id) => {
    addEdge(id, String(nextNodeIndex.value))
  })
  nextNodeIndex.value++

  //add: if node is selected during node creation, then create also an edge
}
/* removes any selected node or edge */
function remove() { 
  for (let nodeId of selectedNodes.value) {
    delete nodes[nodeId]
    for (let edgeID in edges) {
      const e = edges[edgeID]
      if (e.source == nodeId || e.target == nodeId) {
        delete edges[edgeID]
      }
    }
  }
  for (let edgeID of selectedEdge.value) {
    delete edges[edgeID]
  }
}

function addEdge(src:string, trgt?:string) {
  // currently edgeID can be assigned to an already existing ID, causing problems
  if (trgt==undefined) {
    for (let e of Object.values(edges)){
      // Each node can have only one loop
      if (src == e.target && e.source == e.target) {
        return;
      }
    }
    trgt = src
  }

  let newEdge :Transition = {
    source:src,
    target:trgt,
    label: "*",
    ruleType: "ALL",
    charset: [],
  }
  edges[nextEdgeIndex.value] = newEdge
  nextEdgeIndex.value++
}

function validate(text:string){
  console.log(`validate: ${text}`);
  console.log(automata.value.toString());
  automata.value.evaluate(text, animated.value, determinism.value);
}

function handleKeyboard(keydown: string, event:Event) {
  switch (keydown) {
    case "n":
      event.preventDefault()
      addNode();
      break;
    case "e":
      event.preventDefault()
      addEdge(selectedNodes.value[0], selectedNodes.value[1])
  }
}

// watcher: funzione eseguita 
watch(params,()=>{
  // localStorage vs sessionStorages
  localStorage.setItem("graph", graphString(params.value))
})

const eventHandlers: vNG.EventHandlers = {
    "node:contextmenu": ({node, event}) => {
      event.preventDefault()
      event.stopPropagation()
      if (selectedNodes.value.length !== 1)
        selectedNodes.value[0] = selectedNodes.value[1]
      selectedNodes.value[1] = node      
    },
    "edge:contextmenu" : ({edge, event})=>{
      event.preventDefault()
      event.stopPropagation()
      selectedEdge.value[0] = edge!      
      }
  }


return (_ctx: any,_cache: any) => {
  const _component_v_edge_label = _resolveComponent("v-edge-label")!
  const _component_v_network_graph = _resolveComponent("v-network-graph")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SideMenu),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_network_graph, {
          ref_key: "graph",
          ref: graph,
          nodes: _unref(nodes),
          edges: _unref(edges),
          configs: _unref(networkGraphConfigs),
          layouts: _unref(initialParams).layout,
          "event-handlers": eventHandlers,
          "selected-edges": selectedEdge.value,
          "onUpdate:selected-edges": _cache[0] || (_cache[0] = ($event: any) => ((selectedEdge).value = $event)),
          "selected-nodes": selectedNodes.value,
          "onUpdate:selected-nodes": _cache[1] || (_cache[1] = ($event: any) => ((selectedNodes).value = $event)),
          tabindex: "0",
          onKeydown: [
            _withKeys(remove, ["delete"]),
            _cache[2] || (_cache[2] = ($event: any) => (handleKeyboard($event.key, $event)))
          ]
        }, {
          "edge-label": _withCtx(({ edge, ...slotProps }) => [
            _createVNode(_component_v_edge_label, _mergeProps({
              text: edge.label,
              color: "#fbfaf5",
              align: "center",
              "vertical-align": "above"
            }, slotProps), null, 16, ["text"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("defs", null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(palette)), 1)
                ]),
                _: 1
              }))
            ])
          ]),
          _: 1
        }, 8, ["nodes", "edges", "configs", "layouts", "selected-edges", "selected-nodes", "onKeydown"]),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (selectedEdge.value.length === 1)
              ? (_openBlock(), _createBlock(EdgeEditor, {
                  key: 0,
                  edgeId: selectedEdge.value[0],
                  modelValue: _unref(edges)[selectedEdge.value[0]],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(edges)[selectedEdge.value[0]]) = $event))
                }, null, 8, ["edgeId", "modelValue"]))
              : (selectedNodes.value.length === 1)
                ? (_openBlock(), _createBlock(NodeEditor, {
                    key: 1,
                    "node-id": selectedNodes.value[0],
                    modelValue: _unref(nodes)[selectedNodes.value[0]],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(nodes)[selectedNodes.value[0]]) = $event))
                  }, null, 8, ["node-id", "modelValue"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(FootBar, {
        onValidate: _cache[5] || (_cache[5] = (text)=>validate(text)),
        onAddNode: _cache[6] || (_cache[6] = ($event: any) => (addNode())),
        onRemove: remove,
        onAddEdge: _cache[7] || (_cache[7] = ($event: any) => (addEdge(selectedNodes.value[0], selectedNodes.value[1]))),
        onSave: _cache[8] || (_cache[8] = ($event: any) => (_unref(save)(_unref(params), graph.value!))),
        onShare: _cache[9] || (_cache[9] = ($event: any) => (_unref(share)(_unref(params)))),
        onDownloadSVG: _cache[10] || (_cache[10] = ($event: any) => (_unref(downloadAsSvg)(graph.value!))),
        onFindAMatch: _cache[11] || (_cache[11] = ($event: any) => (_unref(automata).findAMatch())),
        determinism: determinism.value,
        "onUpdate:determinism": _cache[12] || (_cache[12] = ($event: any) => ((determinism).value = $event)),
        alphabet: alphabet.value,
        "onUpdate:alphabet": _cache[13] || (_cache[13] = ($event: any) => ((alphabet).value = $event)),
        animated: animated.value,
        "onUpdate:animated": _cache[14] || (_cache[14] = ($event: any) => ((animated).value = $event)),
        start: initialNode.value,
        "onUpdate:start": _cache[15] || (_cache[15] = ($event: any) => ((initialNode).value = $event)),
        nodes: _unref(nodes)
      }, null, 8, ["determinism", "alphabet", "animated", "start", "nodes"])
    ])
  ], 64))
}
}

})